import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "#FF5537",
              d: "M15.535 22.911l-5.579 2.933c-.489.257-1.093.07-1.35-.42-.102-.194-.138-.417-.1-.634l1.065-6.212c.055-.324-.052-.655-.288-.885L4.77 13.294c-.395-.385-.403-1.019-.018-1.414.154-.157.355-.26.572-.292l6.237-.906c.326-.047.607-.252.753-.547l2.79-5.651c.244-.496.843-.699 1.339-.455.197.098.356.257.454.455l2.789 5.651c.146.295.427.5.753.547l6.237.906c.546.08.925.587.845 1.134-.031.217-.134.419-.291.572l-4.513 4.4c-.236.229-.343.56-.288.884l1.066 6.212c.093.544-.273 1.061-.817 1.154-.217.038-.44.002-.634-.1l-5.579-2.933c-.291-.153-.639-.153-.93 0z",
              transform: "translate(-1072 -844) translate(992 844) translate(80)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }